/* global grecaptcha */
import envConfiguration from "@/services/envValues";

const recaptchaKey = envConfiguration.recaptchaApikey;

export const renderCaptcha = captcha =>
  grecaptcha.ready(() =>
    grecaptcha.render(captcha.id, {
      sitekey: recaptchaKey,
      callback: token => (captcha.token = token),
      "expired-callback": () => (captcha.token = null),
      "error-callback": () => (captcha.token = null)
    })
  );
